"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
    onCreate: function () {
        fhandler.bind(this);
    },
    onInput: function (input) {
        input.reset && fhandler.reset();
    },
    onPrev: function () {
        this.emit('prev', this.input.index);
    },
    onCountryChange: function ({name, region}) {
        fhandler.fill({
            country: name,
            region
        });
    },
    onNext: function () {
        const Form = this.state.form;
        if (!Form.name)
            return this.state.formError.name = true;
        if (!Form.description)
            return this.state.formError.description = true;
        if (!Form.country)
            return this.state.formError.country = true;
        if (!Form.email)
            return this.state.formError.email = true;
        if (!this.state.form.agree_terms)
            return;
        this.emit('next', this.input.index, Form);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Onboarding/components/Profile.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    Locale_template = require("../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    CountryInput_template = require("../../../../components/CountryInput/index.marko"),
    CountryInput_tag = marko_loadTag(CountryInput_template),
    _preserve_tag = marko_loadTag(require("marko/dist/core-tags/components/preserve-tag")),
    Bx_template = require("../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    marko_attrs0 = {
        "class": "w-100 p-lg-5 p-2"
      },
    marko_attrs1 = {
        "class": "card-content"
      },
    marko_attrs2 = {
        "class": "d-flex align-items-center"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("909036"),
    marko_node0 = marko_createElement("img", {
        src: "/images/icons/courses.svg",
        alt: "institution",
        width: "50",
        "class": "mr-4"
      }, "4", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "6", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("br", null, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "form-group"
      },
    marko_attrs4 = {
        "class": "form-group"
      },
    marko_attrs5 = {
        "class": "form-group"
      },
    marko_attrs6 = {
        "class": "form-group"
      },
    marko_node3 = marko_createElement("br", null, "23", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs7 = {
        "class": "mb-1"
      },
    marko_attrs8 = {
        "class": "checkbox checkbox-secondary"
      },
    marko_attrs9 = {
        "for": "agree-terms",
        "class": "font-medium-1"
      },
    marko_attrs10 = {
        href: "/terms"
      },
    marko_node4 = marko_createElement("br", null, "31", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("br", null, "36", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node6 = marko_createElement("br", null, "37", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs11 = {
        "class": "navigation-buttons"
      },
    marko_attrs12 = {
        "class": "btn btn-outline-primary btn-xl text-left d-inline-block"
      },
    marko_node7 = marko_createElement("br", null, "32", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs13 = {
        "class": "px-2"
      };

const fhandler = new FormHandler({ key: 'create-institution', autosave: true });

function render(input, out, __component, component, state) {
  var data = input;

  AutoScroll_tag({
      class: "h-100",
      renderBody: function(out) {
        out.be("div", marko_attrs0, "1", component);

        out.be("div", marko_attrs1, "2", component);

        out.be("h5", marko_attrs2, "3", component);

        out.n(marko_node0, component);

        Locale_tag({
            renderBody: function(out) {
              out.t("Let's start by the institution details");
            }
          }, out, __component, "5");

        out.ee();

        out.n(marko_node1, component);

        out.n(marko_node2, component);

        out.be("div", null, "8", component);

        out.be("div", marko_attrs3, "9", component);

        out.e("input", {
            type: "text",
            value: state.form.name,
            name: "name",
            required: true,
            "class": marko_classValue("form-control form-control-xl pl-4" + (state.formError.name != undefined ? state.formError.name ? " is-invalid" : " is-valid" : "")),
            placeholder: Locale("Name of the institution")
          }, "10", component, 0, 0, {
            onchange: __component.d("change", "__onChange", false)
          });

        out.be("p", {
            "class": marko_classValue("small mt-50 mb-2" + (!state.formError.name ? " d-none" : ""))
          }, "11", component, null, 1);

        Locale_tag({
            text: "Institution name is required"
          }, out, __component, "12");

        out.ee();

        out.ee();

        out.e("div", marko_attrs4, "13", component, 1)
          .e("textarea", {
              type: "text",
              value: state.form.description,
              name: "description",
              "class": marko_classValue("form-control form-control-xl " + (state.formError.description != null ? state.formError.description ? " is-invalid" : " is-valid" : "")),
              placeholder: Locale("Give us a short description"),
              style: marko_styleValue({
                  height: "100px",
                  resize: "none"
                })
            }, "14", component, 0, 0, {
              onchange: __component.d("change", "__onChange", false)
            });

        out.be("div", marko_attrs5, "15", component);

        out.e("input", {
            type: "text",
            value: state.form.email,
            name: "email",
            required: true,
            "class": marko_classValue("form-control form-control-xl " + (state.formError.email != null ? state.formError.email ? " is-invalid" : " is-valid" : "")),
            placeholder: Locale("Email Address of your institution"),
            validate: "email"
          }, "16", component, 0, 0, {
            onchange: __component.d("change", "__onChange", false)
          });

        out.be("p", {
            "class": marko_classValue("small mt-50 mb-2" + (!state.formError.email ? " d-none" : ""))
          }, "17", component, null, 1);

        Locale_tag({
            text: "Institution Email Address"
          }, out, __component, "18");

        out.ee();

        out.ee();

        out.be("div", marko_attrs6, "19", component);

        CountryInput_tag({
            class: "rounded",
            size: "xl",
            returnLabel: true,
            returnFields: [
                "name",
                "region"
              ],
            name: "country",
            required: true,
            value: state.form.country,
            validate: "required",
            placeholder: Locale("Location Country")
          }, out, __component, "20", [
          [
            "change",
            "onCountryChange",
            false
          ]
        ]);

        out.be("p", {
            "class": marko_classValue("small mt-50 mb-2" + (!state.formError.country ? " d-none" : ""))
          }, "21", component, null, 1);

        Locale_tag({
            text: "Institution address is required"
          }, out, __component, "22");

        out.ee();

        out.ee();

        out.n(marko_node3, component);

        out.be("div", marko_attrs7, "24", component);

        out.be("div", marko_attrs8, "25", component);

        _preserve_tag({
            n: true,
            renderBody: function(out) {
              out.e("input", {
                  type: "checkbox",
                  id: "agree-terms",
                  name: "agree_terms",
                  checked: state.form.agree_terms
                }, "26", component, 0, 0, {
                  onchange: __component.d("change", "__onChecked", false)
                });
            }
          }, out, __component, "26");

        out.be("label", marko_attrs9, "27", component);

        Locale_tag({
            text: "I agree to the"
          }, out, __component, "28");

        out.be("a", marko_attrs10, "29", component);

        out.t(" ");

        Locale_tag({
            class: "text-primary",
            text: "terms of user & privacy policy"
          }, out, __component, "30");

        out.ee();

        out.ee();

        out.ee();

        out.ee();

        out.n(marko_node4, component);

        if (state.alert) {
          out.n(marko_node7, component);

          out.be("div", marko_attrs13, "33", component);

          out.be("div", {
              "class": marko_classValue(marko_classValue([
                "alert",
                "border-" + state.alert.type
              ]))
            }, "34", component, null, 1);

          Locale_tag({
              text: state.alert.message
            }, out, __component, "35");

          out.ee();

          out.ee();
        }

        out.ee();

        out.ee();

        out.n(marko_node5, component);

        out.n(marko_node6, component);

        out.be("div", marko_attrs11, "38", component);

        out.be("button", marko_attrs12, "39", component, null, 0, {
            onclick: __component.d("click", "onPrev", false)
          });

        Locale_tag({
            text: "Back",
            class: "px-3"
          }, out, __component, "40");

        out.ee();

        out.be("button", {
            disabled: !state.form.agree_terms,
            "class": "btn btn-primary btn-xl text-left d-inline-block float-right w-50"
          }, "41", component, null, 0, {
            onclick: __component.d("click", "onNext", false)
          });

        Bx_tag({
            type: "right-arrow-alt",
            class: "font-large-1 float-right white-text"
          }, out, __component, "42");

        Locale_tag({
            text: "Continue"
          }, out, __component, "43");

        out.ee();

        out.ee();

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
